import { FormControlLabel, FormHelperText, Grid, Radio, RadioGroup } from "@mui/material";
import { useEffect } from "react";
import tor from '../../../media/ToR-experts-SPICE-2025.pdf';

const SubmissionStep = ({ props }) => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])
    
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
                <p>
                    If you agree to register, any processing of provided data will comply with EU Regulations 45/2001 and 2018/1725. As the host of the registry, Radboudumc is the main data controller of this processing operation.
                </p>
                <p>
                    I hereby confirm that I understand the <a href={tor} target="_blank" rel="noopener noreferrer">Terms of Reference</a> and express interest to be considered for the SPICE Registry. I give my consent to Radboudumc to use my personal data only for the purposes of the SPICE registry as described in the Terms of Reference. I also understand that I can withdraw my data at any time, by informing the SPICE registry contact point by e-mail.
                </p>
            </Grid>
            <Grid item xs={12} container >
                <Grid item>
                    {props.consentError && <FormHelperText><b style={{ color: '#d32f2f' }}>{props.consentError}</b></FormHelperText>}
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Grid item>
                    <RadioGroup aria-label="consent" name="consent" value={props.acceptConsent} onChange={props.handleAcceptConsent} row >
                        <FormControlLabel value="yes" control={<Radio checked={props.formData.consent === true || props.formData.consent === 'yes'} />} label="Yes" />
                        <FormControlLabel value="no" control={<Radio />} label="No" />
                    </RadioGroup>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default SubmissionStep;